// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { forwardRef } from 'react';
import type { GlobalProps } from '@bloomberg/media-ui-core';
import { classes, useSlug } from '@bloomberg/media-ui-core';

import { formatValue } from '../utils/index';

import styles from './SizedPrice.module.css';

type Size = 'default' | 'small' | 'large' | 'extraLarge';

export type SizedPriceProps = {
  price: number;
  size?: Size;
  currency?: string;
  precision?: number;
  isDark?: boolean;
} & GlobalProps;

function formatChange(changeValue: number, precision?: number) {
  if (changeValue <= 0) {
    return formatValue(changeValue, precision).replace('-', '–');
  }

  return `${formatValue(changeValue, precision)}`;
}

export const SizedPrice = forwardRef<HTMLDivElement, SizedPriceProps>(
  function SizedPriceComponent(props: SizedPriceProps, ref) {
    const {
      price,
      size = 'default',
      currency,
      name = 'SizedPrice',
      precision,
      isDark = false,
    } = props;
    const componentName = useSlug(name);

    const formattedPrice = formatChange(price, precision);

    return (
      <div
        ref={ref}
        data-component={componentName}
        className={classes(
          [
            componentName,
            styles[size],
            isDark && styles.isDark,
            styles.tabular,
          ],
          props
        )}
      >
        {formattedPrice}
        {currency && <span className={styles.currency}>{currency}</span>}
      </div>
    );
  }
);
